import { whizBranding } from './whiz';
import { prosaBranding } from './prosa';
import { whizFarmaBranding } from './whizFarma';
import type { BrandingConfig, BrandingKey } from './types';

/**
 * Marcas disponíveis. A escolha é de EXECUÇÃO, não de build: a imagem Docker é
 * uma só e o contêiner escreve `window.configs.COMPANY` a partir de
 * `public/config.js.template` (ver o `envsubst` no CMD do Dockerfile).
 *
 * Para acrescentar uma marca: um arquivo novo aqui ao lado, uma entrada neste
 * mapa, a chave em `BrandingKey` (types.ts) e um bloco de tokens em
 * `assets/css/branding.css`. Nada além disso — os ~47 componentes que leem
 * `branding.*` passam a servir a marca nova sozinhos.
 */
const brandings: Record<BrandingKey, BrandingConfig> = {
  WHIZ: whizBranding,
  PROSA: prosaBranding,
  WHIZ_FARMA: whizFarmaBranding,
};

/** Marca usada quando `COMPANY` vem vazio ou com um valor desconhecido. */
const MARCA_PADRAO: BrandingKey = 'WHIZ';

function ehChaveConhecida(valor: unknown): valor is BrandingKey {
  return typeof valor === 'string' && valor in brandings;
}

export function getBranding(): BrandingConfig {
  // A comparação era `COMPANY === 'PROSA' ? 'PROSA' : 'WHIZ'`, que não tinha
  // como crescer: qualquer marca nova cairia silenciosamente na Whiz. Agora a
  // chave é procurada no mapa, e só o desconhecido cai no padrão — com aviso,
  // porque "subiu com COMPANY errado" é indistinguível de "é Whiz mesmo".
  const configurada = window.configs?.COMPANY;

  if (ehChaveConhecida(configurada)) return brandings[configurada];

  if (configurada) {
    console.warn(
      `[branding] COMPANY="${String(configurada)}" não é uma marca conhecida ` +
      `(${Object.keys(brandings).join(', ')}). Usando ${MARCA_PADRAO}.`,
    );
  }

  return brandings[MARCA_PADRAO];
}

export const branding = getBranding();

export type { BrandingConfig, BrandingKey };
